import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ResponsiveService, ToastService} from '@core/src/public-api';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'si-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.scss']
})
export class ShareDialogComponent implements OnInit {
  @Input() displayDialog: boolean;
  @Input() dialogTitle: string;
  @Input() dialogText: string;
  @Input() url: string;
  @Input() pin: string;
  @Input() expirationTime: number;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  isDesktop: boolean;
  showShare: boolean;
  showCopy: boolean;
  error: string;

  constructor(
    private responsiveService: ResponsiveService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {
    this.setResponsiveLogic();
  }

  ngOnInit(): void {
    this.showShare = !this.isDesktop && !!navigator.share;
    this.showCopy = !!navigator.clipboard;
  }

  setResponsiveLogic(): void {
    this.isDesktop = this.responsiveService.isDesktop();
  }

  onVisibleChange(value: boolean): void {
    this.displayDialog = value;
    this.displayDialogChange.emit(this.displayDialog);
  }

  onClickShare(): void {
    if (navigator.share) {
      navigator.share({
        title: this.dialogText,
        text: `${this.translateService.instant('SI_SHARE_URL_INFO')} ${this.dialogText}`,
        url: this.url
      })
        .then(() => console.log(this.translateService.instant('SI_SHARE_URL_SUCCESS')))
        .catch((error) => {
          this.error = error;
          this.toastService.error('SI_SHARE_ERROR', error);
        });
    } else {
      this.error = 'SI_SHARE_API_NOT_SUPPORTED';
      this.toastService.error(this.error);
    }
  }

  onClickCopy(): void {
    const textToCopy = this.url;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => this.toastService.success('SI_COPY_URL_SUCCESS'))
        .catch(error => {
          this.error = error;
          this.toastService.error('SI_COPY_ERROR', error);
        });
    } else {
      this.error = 'SI_CLIPBOARD_API_NOT_SUPPORTED';
      this.toastService.error(this.error);
    }
  }
}
